module.exports = __webpack_public_path__ + "static/media/red-cross.326069fe.png";